import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { inicializarDesktop } from "@/lib/platform";

// Inicializa API nativa quando rodando como app desktop
inicializarDesktop();

createRoot(document.getElementById("root")!).render(<App />);

// PostHog analytics: carrega de forma assincrona para nao bloquear TTI
requestIdleCallback(() => {
  import("posthog-js").then(({ default: posthog }) => {
    posthog.init("phc_tNkUUAf854JdSbvFbjbWnLswFLQ3kAR9AfvSmB3pNxAr", {
      api_host: "https://us.i.posthog.com",
      capture_pageview: true,
      capture_pageleave: true,
      autocapture: true,
    });
  });
});
